<template>
  <div class="dashboard-metrics-container">
    <div v-for="metric in metrics" :key="metric.title" class="metric-item">
      <div class="item-title">{{ metric.title }}</div>
      <div v-if="metric.tooltip" class="item-description">{{ `(${metric.tooltip})` }}</div>
      <div class="item-metric">
        <span v-if="metric.isCurrency" class="card-number description">R$</span>
        <span class="card-number">{{ metric.numberText }}{{ metric.isPercent && !metric.numberText.includes('%') ? '%' : '' }}</span>
      </div>
      <div v-if="metric.percentText || metric.percentDescription" class="item-metric-percent">
        <span v-if="metric.percentText" class="percent-text" :class="getPercentageClass(metric)">{{ metric.percentText }}</span>
        <span v-if="metric.percentDescription" class="percent-description">{{ metric.percentDescription }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardMetrics',
  props: {
    metrics: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    percentNumber(item) {
      if (!item.percentText) return 0
      const text = item.percentText.replace('%', '').replace(',', '.')
      return Number(text) || 0
    },
    getPercentageClass(item) {
      if (item.unsetPercentageColors || this.percentNumber(item) === 0) {
        return 'unset-color'
      }
      return this.percentNumber(item) > 0 ? 'positive' : 'negative'
    },
  },
}
</script>

<style lang="scss" scoped>
.dashboard-metrics-container {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
  padding: 0;

  .metric-item {
    padding: 20px 24px 24px 24px;
    width: calc(33.333% - 1px);
    box-sizing: border-box;
    border-right: solid 1px $cinza-l40;
    border-bottom: solid 1px $cinza-l40;
    height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;

    &:nth-child(3n) {
      border-right: none;
    }

    &:nth-child(n + 7) {
      border-bottom: none;
    }

    .item-title {
      color: $cinza-d10;
      font-size: 15px;
      font-weight: 700;
      line-height: 1.3;
      letter-spacing: 0.15px;
      margin-bottom: 10px;
      min-height: 40px;
    }

    .item-description {
      color: $cinza-d10;
      font-size: 11px;
      font-weight: 400;
      line-height: 1.3;
      letter-spacing: 0.11px;
      margin-bottom: 14px;
    }

    .item-metric {
      margin-bottom: 14px;
      flex: 1;
      display: flex;
      align-items: flex-end;
      .card-number {
        color: $cinza-0;
        font-size: 30px;
        font-weight: 400;
        letter-spacing: 0.3px;
        line-height: 1;
        word-break: break-word;
      }
      .description {
        color: $cinza-l40;
        margin-right: 2px;
        font-size: 30px;
      }
    }

    .item-metric-percent {
      margin-top: auto;
      span {
        line-height: 1.3;
        font-size: 13px;
      }
      .percent-text {
        font-weight: 700;
        margin-right: 4px;
      }
      .percent-description {
        color: $cinza-0;
        font-weight: 400;
        font-size: 12px;
      }
    }
  }
}

.unset-color {
  color: $cinza-d10;
}
.positive {
  color: $verde-0;
}
.negative {
  color: $vermelho-0;
}
</style>
